import { PaymentMethodType } from "@a_team/models/dist/PaymentMethod";

export const PaymentMethodTypes: Partial<Record<string, PaymentMethodType>> = {
  card: PaymentMethodType.CARD,
  us_bank_account: PaymentMethodType.ACH_DEBIT,
};
